export const SOURCE_CHANNEL_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'shopify', label: 'Shopify' },
  { value: 'canva', label: 'Canva' },
];

export const SOURCE_TYPE_OPTIONS = [
  { value: 'template', label: 'Template' },
  { value: 'design_scratch', label: 'Design Scratch' },
  { value: 'import_json', label: 'Import JSON' },
  { value: 'ai_assisted', label: 'AI Assisted' },
];

export const normalizeSourceChannel = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return normalized || 'normal';
};

export const getSourceBadgeLabel = (value) => {
  const normalized = normalizeSourceChannel(value);
  const found = SOURCE_CHANNEL_OPTIONS.find((option) => option.value === normalized);
  return found?.label || 'Normal';
};
